module.exports = __webpack_public_path__ + "static/media/profile-card-rocket.321a8c01.svg";